import { Actions } from '../../types/actions';
import { INITIALIZE_APPLICATION, CHANGE_INTERNAL_PRICE } from '../../types/constants';
const initialState = false;

const initialPrice = (state = initialState, action: Actions): boolean => {
  switch (action.type) {
    case INITIALIZE_APPLICATION:
      return initialState;
    case CHANGE_INTERNAL_PRICE:
      return action.internalPrice;
    default:
      return state;
  }
};

export default initialPrice;
